<template>
  <VueSlider
    ref="slider"
    v-bind="$attrs"
    :contained="true"
    :dotSize="1"
    :height="15"
    :lazy="false"

    :tooltip="tooltip"
    :tooltipFormatter="format"
    :tooltipPlacement="tooltipPosition"
    :value="value"
    @change="$emit('update:value', $event)"
    @drag-start="$emit('drag-start')"
    @error="$emit('error', $event)" />
</template>

<script>
import 'vue-slider-component/theme/antd.css'
import VueSlider from 'vue-slider-component'

export default {
  components: { VueSlider },
  props: {
    format: {
      type: Function,
      default: null,
    },
    tooltip: {
      type: String,
      default: 'always',
    },
    tooltipPosition: String,
    value: {
      type: null,
    },
  },
}
</script>

<style lang="scss">
</style>
